import { Model } from "@vuex-orm/core";

import Unit from "@models/building/Unit";
import UserArticle from "@models/helpers/UserArticle";

export default class SelectedUserArticle extends Model {
    static entity = "selectedUserArticles";
    static primaryKey = ["unitId", "articleId"];
    static fields() {
        return {
            unitId: this.attr(null),
            articleId: this.attr(null),
            quantity: this.number(0),

            userArticle: this.belongsTo(UserArticle, "articleId"),
            unit: this.belongsTo(Unit, "unitId"),
        };
    }

    get article() {
        return this.userArticle;
    }

    getPrice() {
        return this.userArticle.price;
    }

    getTotalPrice() {
        return parseInt(this.userArticle.price * this.quantity);
    }
}
